import {Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef} from '@angular/core';
import {PlaningArea, ScheduleTemplateModel} from '../../../../api/src/template/template.model';
import {ObjectModel} from '../../../../api/src/object/object.model';
import {ScheduleTemplatePeriodModel} from '../../../../api/src/scheduletemplate/scheduletemplate.model';
import {LocaleService} from '../../../../../src/app/shared/services/locale.service';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-work-schedule-view',
  templateUrl: './work-schedule-view.component.html',
  styleUrls: ['./work-schedule-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkScheduleViewComponent implements OnInit, OnChanges {

  @Input() planningareas: PlaningArea[];
  @Input() dailySchedule: ScheduleTemplatePeriodModel;
  @Input() objects: ObjectModel[];
  @Input() selectedObject: {objectId: number, date?: Date} | null  = null;

  @Output() changeObject = new EventEmitter<{objectId: number, date?: Date}>();
  @Output() changeDate = new EventEmitter<Date>();
  loading$ = new BehaviorSubject<boolean>(false);
  public listObjects: {label: string, value: number}[] = [];
  @Input() date = new Date();
  today = new Date();
  calendarLocale;
  currentObject?: ObjectModel;
  selected;

  constructor(private localeService: LocaleService,  private cdr: ChangeDetectorRef) {
    localeService.locale$.subscribe(locale => {
      this.calendarLocale = this.localeService.getCalendarLocale(locale.serverShort);
    });
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {

    if (this.objects) {
      this.objects = this.objects.sort((item1, item2) => item1.shortname.toLowerCase().localeCompare(item2.shortname.toLowerCase()));
      this.listObjects = [{label: ' ', value: -1}, ...(this.objects || []).map(v => ({label: v.shortname, value: v.id}))];
    }
    if (this.dailySchedule) {
      this.loading$.next(false);
    }

    if (this.selected && this.selected !== -1 && !this.dailySchedule) {
      this.loading$.next(true);
    }

    if (this.selectedObject) {
      this.selected = this.selectedObject.objectId;
      this.currentObject = this.objects.find(obj => this.selectedObject.objectId === obj.id);
    }
    if (!this.date) {
      this.date = new Date();
    }
  }
  changeObjectAndDate(objectData) {

    this.loading$.next(true);
    this.currentObject = this.objects.find(o => o.id === objectData.value);
    if (this.currentObject) {
      this.changeObject.emit({objectId: this.currentObject.id, date: this.date});
    } else {
      this.changeObject.emit(null);
    }
  }

  showCalendar() {

  }

  setToday(): void {
    this.date = new Date(this.date.setDate(this.today.getDate()));
    this.onChangeDate();

  }
  nextDate(): void {
    this.date = new Date(this.date.setDate(this.date.getDate() + 1));
    this.onChangeDate();
  }
  prevDate(): void {
    this.date = new Date(this.date.setDate(this.date.getDate() - 1));
    this.onChangeDate();
  }
  onChangeDate() {
    this.loading$.next(true);
    if (this.currentObject) {
      this.changeObject.emit({objectId: this.currentObject.id, date: this.date});
    }
    this.cdr.markForCheck();
  }

}
